<template>
  <div id="campaign-detail-view" class="campaign-detail-view">
    <div class="col-md-12" style="width: 100%; height: 100%">
      <div
        slot="header"
        class="flex flex-wrap items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- EXPORT Excel Data -->
          <div
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-success
              border border-solid border-success
            "
            @click="onExportExcelAll"
          >
            <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-success">{{
              downloadExcelTitle
            }}</span>
          </div>
        </div>
      </div>
      <a-table
        rowKey="doc_id"
        :columns="columns"
        :pagination="false"
        :data-source="tableData"
        :scroll="{ x: 1600, y: 'calc(100vh - 400px)' }"
        @change="handleTableChange"
      >
        <div slot="name" slot-scope="record">
          {{ record.name }}&nbsp;<a-tag
            color="#108ee9"
            v-if="record.usertype === 'FREE'"
            >프리</a-tag
          >
          <a-tag color="#f50" v-else-if="record.usertype === 'PAID'"
            >내부</a-tag
          >
        </div>
        <div slot="title" slot-scope="record">
          <i v-if="record.type === 'REAL'" class="fal fa-clock">&nbsp;</i
          >{{ record.title }}
        </div>
        <div slot="price" slot-scope="record">
          <div style="text-align: right">
            {{ record.price ? record.price.toLocaleString() : 0 }}
          </div>
        </div>
        <div slot="seller" slot-scope="record">
          <div style="text-align: right">
            {{ record.seller ? record.seller.toLocaleString() : 0 }}
          </div>
        </div>
        <div slot="campaign" slot-scope="record">
          {{ record.campaignDone }} / {{ record.campaign }}
        </div>

        <div slot="tperson" slot-scope="record">
          <div style="text-align: right">
            {{ record.tperson ? record.tperson.toLocaleString() : 0 }}
          </div>
        </div>
        <div slot="eperson" slot-scope="record">
          <div style="text-align: right">
            {{ record.eperson ? record.eperson.toLocaleString() : 0 }}
          </div>
        </div>
        <div slot="operson" slot-scope="record">
          <div style="text-align: right">
            {{ record.operson ? record.operson.toLocaleString() : 0 }}
          </div>
        </div>
        <div slot="missioncomplete" slot-scope="record">
          <div style="text-align: right" v-if="record.type === 'REAL'">
            {{
              record.missioncomplete
                ? record.missioncomplete.toLocaleString()
                : 0
            }}
          </div>
          <div style="text-align: right" v-else>
            {{
              record.missioncomplete
                ? record.missioncomplete.toLocaleString()
                : 0
            }}
          </div>
        </div>
        <div slot="missionincomplete" slot-scope="record">
          <div style="text-align: right">
            {{
              record.missionincomplete
                ? record.missionincomplete.toLocaleString()
                : 0
            }}
          </div>
        </div>

        <div slot="tpersonprev" slot-scope="record">
          <div style="text-align: right">
            {{ record.tpersonprev ? record.tpersonprev.toLocaleString() : 0 }}
          </div>
        </div>
        <div slot="epersonprev" slot-scope="record">
          <div style="text-align: right">
            {{ record.epersonprev ? record.epersonprev.toLocaleString() : 0 }}
          </div>
        </div>
        <div slot="opersonprev" slot-scope="record">
          <div style="text-align: right">
            {{ record.opersonprev ? record.opersonprev.toLocaleString() : 0 }}
          </div>
        </div>
        <!-- <div slot="missioncompleteprev" slot-scope="record">
                            <div style="text-align:right" v-if="record.type=='REAL'"> ②&nbsp;{{record.missioncompleteprev? record.missioncompleteprev.toLocaleString() :0}}</div>
                            <div style="text-align:right" v-else> {{record.missioncompleteprev? record.missioncompleteprev.toLocaleString() :0}}</div>
                        </div> -->
        <div slot="fee" slot-scope="record">
          <div style="text-align: right" v-if="record.type === 'REAL'">
            {{ record.fee ? record.fee.toLocaleString() : 0 }}
          </div>
          <div style="text-align: right" v-else>
            {{ record.fee ? record.fee.toLocaleString() : 0 }}
          </div>
        </div>

        <div slot="elapsed" slot-scope="record">
          <div style="text-align: right">
            <span v-if="record.usertype === 'PAID' && record.elapsed > 180"
              >500,000</span
            >
          </div>
        </div>
        <div slot="initdate" slot-scope="record">
          <div style="text-align: right">
            <span
              >{{
                record.elapsed ? record.elapsed.toLocaleString() : 0
              }}일</span
            >
          </div>
        </div>

        <div slot="totalfee" slot-scope="record">
          <div>
            {{ record.totalfee ? record.totalfee.toLocaleString() : 0 }}
          </div>
        </div>

        <div slot="action" slot-scope="text, record">
          <a-button
            style="width: 90px"
            type="primary"
            @click="onLoadDetailList(record.md, record.monthId)"
            >상세보기</a-button
          >
        </div>
      </a-table>
    </div>

    <a-modal
      class="fullscreen"
      v-model="visible"
      :title="'상세보기'"
      centered
      width="100vw"
    >
      <template slot="footer">
        <a-button key="submit" type="primary" @click="visible = false">
          닫기
        </a-button>
        <a-button @click="onExportExcel()">{{ downloadExcelTitle }}</a-button>
      </template>
      <a-table rowKey="doc_id" :columns="ccolumns" :data-source="ctableData">
      </a-table>
    </a-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
Date.prototype.addDays = function (days) {
  const date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)
  return date
}

Date.prototype.addHours = function (h) {
  const timestamp = h * 60 * 60 * 1000
  this.setTime(this.getTime() + timestamp)
  return this
}

String.prototype.trims = function () {
  return this.replace(/^\s+|\s+$/g, "")
}

import SubMenu from "../../../layouts/components/nav/SubMenu"
import NavFooter from "../../../layouts/components/nav/NavFooter.vue"
import firebase from "firebase"
import {
  getCurrentTime2,
  getCurrentDate4,
  getCurrentDate5,
  dateDiffInDaysGap,
  isMobile
} from "../../components/fnc"

import XLSX from "xlsx"
import FileSaver from "file-saver"

export default {
  data () {
    return {
      downloadExcelTitle: "엑셀 다운로드",
      visible: false,
      ctableData: [],
      tableData: [],
      originalTableData: [],
      allCampaigns: [],
      users: [],
      title1: "전체 인원수",
      title2: "이벤트",
      title3: "실제인원",
      title4: "①미션완료인원",
      title5: "미진행인원",
      columns: [
        {
          width: "0px",
          key: "date"
        },
        {
          title: "이름",
          width: "80px",
          key: "name",
          align: "center",
          scopedSlots: {
            customRender: "name"
          },
          filters: []
        },
        {
          title: "내용",
          width: "170px",
          key: "title",
          align: "center",
          scopedSlots: {
            customRender: "title"
          },
          filters: []
        },
        {
          title: "매출(VAT포함)",
          key: "price",
          width: "120px",
          align: "center",
          scopedSlots: {
            customRender: "price"
          }
        },
        {
          title: "계약 판매자수",
          key: "seller",
          width: "100px",
          align: "center",
          scopedSlots: {
            customRender: "seller"
          }
        },
        {
          title: "캠페인 수(완료)/(총)",
          key: "campaign",
          width: "90px",
          align: "center",
          scopedSlots: {
            customRender: "campaign"
          }
        },
        {
          title: "당월",
          key: "month",
          align: "center",
          children: [
            {
              title: "",
              key: "tperson",
              width: "90px",
              align: "center",
              scopedSlots: {
                customRender: "tperson"
              }
            },
            {
              title: "",
              key: "eperson",
              width: "90px",
              align: "center",
              scopedSlots: {
                customRender: "eperson"
              }
            },
            {
              title: "",
              key: "operson",
              width: "90px",
              align: "center",
              scopedSlots: {
                customRender: "operson"
              }
            },
            {
              title: "",
              key: "missioncomplete",
              width: "110px",
              align: "center",
              scopedSlots: {
                customRender: "missioncomplete"
              }
            },
            {
              title: "",
              key: "missionincomplete",
              width: "90px",
              align: "center",
              scopedSlots: {
                customRender: "missionincomplete"
              }
            }
          ]
        },
        {
          title: "이월",
          key: "monthprev",
          align: "center",
          children: [
            {
              title: "전체 인원수",
              key: "tpersonprev",
              width: "90px",
              align: "center",
              scopedSlots: {
                customRender: "tpersonprev"
              }
            },
            {
              title: "이벤트",
              key: "epersonprev",
              width: "80px",
              align: "center",
              scopedSlots: {
                customRender: "epersonprev"
              }
            },
            {
              title: "②실제인원",
              key: "opersonprev",
              width: "90px",
              align: "center",
              scopedSlots: {
                customRender: "opersonprev"
              }
            },
            {
              title: "①+②당월수익",
              key: "fee",
              width: "110px",
              align: "center",
              scopedSlots: {
                customRender: "fee"
              }
            }
          ]
        },
        {
          title: "③당월수수료",
          key: "elapsed",
          align: "center",
          width: "110px",
          scopedSlots: {
            customRender: "elapsed"
          }
        },
        {
          title: "①+②-③정산수익",
          key: "totalfee",
          width: "120px",
          align: "center",
          scopedSlots: {
            customRender: "totalfee"
          }
        },
        {
          title: "입사후경과일",
          key: "initdate",
          scopedSlots: {
            customRender: "initdate"
          },
          align: "center",
          width: "100px"
        },
        {
          title: "상세내역",
          key: "action",
          align: "center",
          width: "110px",
          scopedSlots: {
            customRender: "action"
          }
        }
      ],
      ccolumns: [
        {
          title: "주문번호",
          dataIndex: "order_id",
          key: "order_id",
          align: "left",
          width: "160px"
        },
        {
          title: "계약일",
          key: "contract_date",
          align: "left",
          dataIndex: "contract_date",
          width: "110px"
        },
        {
          title: "판매자명",
          key: "seller_name",
          dataIndex: "seller_name",
          align: "left",
          width: "100px"
        },
        {
          title: "제품명",
          key: "title",
          dataIndex: "title",
          align: "left"
        },
        {
          title: "전체인원수",
          key: "max_applier_cnt",
          dataIndex: "max_applier_cnt",
          align: "left",
          width: "100px"
        },
        {
          title: "실제진행수",
          key: "org_applier_cnt",
          dataIndex: "org_applier_cnt",
          align: "left",
          width: "100px"
        },
        {
          title: "이벤트인원",
          key: "event_applier_cnt",
          align: "left",
          dataIndex: "event_applier_cnt",
          width: "100px"
        },
        {
          title: "건당배분액",
          key: "per_amount",
          align: "left",
          dataIndex: "per_amount",
          width: "100px"
        },
        {
          title: "총 수익",
          key: "total",
          align: "left",
          dataIndex: "total",
          width: "120px"
        },
        {
          title: "상태",
          key: "campaign_state_cd",
          align: "left",
          dataIndex: "campaign_state_cd",
          width: "110px"
        },
        {
          title: "종료(예정)일",
          key: "end_date",
          align: "left",
          dataIndex: "end_date",
          width: "120px"
        },
        {
          title: "적립(예정)일",
          key: "saving_date",
          align: "left",
          dataIndex: "saving_date",
          width: "120px"
        }
      ]
    }
  },
  computed: {
    getUid () {
      return this.$store.state.AppActiveUser.uid
    },
    getEmail () {
      return this.$store.state.AppActiveUser.email
    },
    getMD () {
      return this.$store.state.AppActiveUser.ismd
    }
  },
  components: {
    SubMenu,
    NavFooter
  },
  async mounted () {
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true)
    const self = this

    this.columns[6].children[0].title = this.title1
    this.columns[6].children[1].title = this.title2
    this.columns[6].children[2].title = this.title3
    this.columns[6].children[3].title = this.title4
    this.columns[6].children[4].title = this.title5
    this.tableData = []
    this.$vs.loading()

    await this.onLoadMember()

    const _dummy = this.tableData
    this.tableData = _dummy.sort(function (a, b) {
      // desc
      return a.monthId > b.monthId ? -1 : a.monthId < b.monthId ? 1 : 0
    })

    const _title = new Map()
    this.tableData.forEach(item => {
      _title.set(item.title, item.title)
    })

    _title.forEach(item => {
      self.columns[2].filters.push({
        text: item,
        value: item
      })
    })

    this.onRecalculate()

    this.$vs.loading.close()
  },
  methods: {
    onExportExcelAll () {
      const date = new Date()
      const self = this
      const e1 = [
        [
          "이름",
          "내용",
          "계약판매자수",

          "전체인원수",
          "이벤트",
          "실제인원",
          "미션완료인원",
          "미진행인원",

          "당월수수료",
          "정산수익",
          "입사후경과일"
        ]
      ]

      const wb = XLSX.utils.book_new()

      this.tableData.forEach(item => {
        const _elapsed =
          item.usertype === "PAID" && item.elapsed > 180 ? 500000 : 0
        const _initdate = item.elapsed ? `${item.elapsed}일` : "0일"

        e1.push([
          item.name,
          item.title,
          item.seller,

          item.tperson,
          item.eperson,
          item.operson,
          item.missioncomplete,
          item.missionincomplete,
          _elapsed,
          item.totalfee,
          _initdate
        ])
      })

      const ws1 = XLSX.utils.aoa_to_sheet(e1)

      // var ws2 = XLSX.utils.aoa_to_sheet(ws_data);

      XLSX.utils.book_append_sheet(wb, ws1, "데이타")

      // XLSX.utils.book_append_sheet(wb, ws2, 't2');

      // var wb = XLSX.utils.table_to_book(document.querySelector("#single"));

      const wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      })

      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream"
          }),
          `스토어링크-MD-실적-.${date.getTime()}.xlsx`
        )
      } catch (e) {
        console.error(e)
      }
      return wbout
    },
    onExportExcel () {
      const date = new Date()
      const self = this
      const e1 = [
        [
          "주문번호",
          "계약일",
          "판매자명",
          "제품명",
          "전체인원수",
          "실제인원수",
          "이벤트인원",
          "건당배분액",
          "총 수익",
          "상태",
          "종료(예정)일",
          "적립(예정)일"
        ]
      ]

      const wb = XLSX.utils.book_new()

      this.ctableData.forEach(item => {
        e1.push([
          item.order_id,
          item.contract_date,
          item.seller_name,
          item.title,
          item.max_applier_cnt,
          item.org_applier_cnt,
          item.event_applier_cnt,
          item.per_amountn,
          item.totaln,
          item.campaign_state_cd,
          item.end_date,
          item.saving_date
        ])
      })

      const ws1 = XLSX.utils.aoa_to_sheet(e1)

      // var ws2 = XLSX.utils.aoa_to_sheet(ws_data);

      XLSX.utils.book_append_sheet(wb, ws1, "데이타")

      // XLSX.utils.book_append_sheet(wb, ws2, 't2');

      // var wb = XLSX.utils.table_to_book(document.querySelector("#single"));

      /* get binary string as output */
      const wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      })

      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream"
          }),
          `MD-실적-.${date.getTime()}.xlsx`
        )
      } catch (e) {
        console.error(e)
      }
      return wbout
    },
    onRecalculate () {
      let _t1 = 0
      let _t2 = 0
      let _t3 = 0
      let _t4 = 0
      let _t5 = 0

      this.tableData.forEach(item => {
        _t1 += item.tperson ? item.tperson : 0
        _t2 += item.eperson ? item.eperson : 0
        _t3 += item.operson ? item.operson : 0
        _t4 += item.missioncomplete ? item.missioncomplete : 0
        _t5 += item.missionincomplete ? item.missionincomplete : 0
      })

      this.columns[6].children[0].title = `${this.title1} (${parseInt(
        _t1
      ).toLocaleString()})`
      this.columns[6].children[1].title = `${this.title2} (${parseInt(
        _t2
      ).toLocaleString()})`
      this.columns[6].children[2].title = `${this.title3} (${parseInt(
        _t3
      ).toLocaleString()})`
      this.columns[6].children[3].title = `${this.title4} (${parseInt(
        _t4
      ).toLocaleString()})`
      this.columns[6].children[4].title = `${this.title5} (${parseInt(
        _t5
      ).toLocaleString()})`
    },
    onChangeMdByFilter (_name, _title) {
      this.tableData = []
      if (_name.length === 0 && _title.length === 0) {
        this.tableData = this.originalTableData
      } else {
        this.tableData = this.originalTableData.filter(item => {
          if (
            (_name.find(sitem => sitem === item.md) &&
              _title.find(sitem => sitem === item.title) &&
              _name.length !== 0 &&
              _title.length !== 0) ||
            (_name.length !== 0 &&
              _title.length === 0 &&
              _name.find(sitem => sitem === item.md)) ||
            (_title.length !== 0 &&
              _name.length === 0 &&
              _title.find(sitem => sitem === item.title))
          ) {
            return item
          }
        })
      }
      this.onRecalculate()
    },
    handleTableChange (pagination, filters, sorter) {
      this.onChangeMdByFilter(
        filters.name ? filters.name : [],
        filters.title ? filters.title : []
      )
    },
    async onLoadMember () {
      const self = this
      const db = firebase.firestore()

      self.tableData = []
      self.allCampaigns = []
      self.originalTableData = []

      const _dummy = []
      this.users = []
      this.users.push({
        name: "전체",
        value: "0"
      })

      await db
        .collection("retail_user")
        .get()
        .then(async function (querySnapshot) {
          const promises = []
          querySnapshot.forEach(function (doc) {
            self.users.push({
              name: doc.data().name,
              value: doc.data().member_id
            })
            self.columns[1].filters.push({
              text: doc.data().name,
              value: doc.data().member_id
            })

            promises.push(
              self.onLoadCurrent(
                doc.data().user_type,
                doc.data().name,
                doc.data().member_id,
                doc.data().reg_date
              )
            )
            // await self.onLoadHistory(doc.data().name, doc.data().member_id)
          })
          await Promise.all(promises)
        })
    },
    onLoadDetailList (_md, _monthId) {
      this.ctableData = []
      const self = this
      this.allCampaigns.forEach(item => {
        if (
          (item.end_month === _monthId && item.member_id === _md) ||
          (item.contract_date.substr(0, 6) === _monthId &&
            item.member_id === _md &&
            item.end_month === null)
        ) {
          const _t = {
            // set rowKey
            doc_id: item.doc_id,
            order_id: item.order_id,
            contract_date: item.contract_date,
            seller_name: item.seller_name,
            title: item.title,
            org_applier_cnt: item.org_applier_cnt,
            max_applier_cnt: item.max_applier_cnt,
            event_applier_cnt: item.event_applier_cnt,
            per_amountn: item.per_amount,
            per_amount: `${parseInt(item.per_amount).toLocaleString()}원`,
            totaln: item.per_amount * item.org_applier_cnt,
            total: `${(
              parseInt(item.per_amount) * parseInt(item.org_applier_cnt)
            ).toLocaleString()}원`,
            campaign_state_cd:
              item.campaign_state_cd === "0803" ? "캠페인완료" : "진행중",
            end_date: item.end_date,
            saving_date: item.saving_date
          }

          self.ctableData.push(_t)
        }
      })

      this.visible = true
    },
    _mobile () {
      return isMobile()
    },
    async onLoadCurrent (_usertype, _name, _md, _reg_date) {
      const self = this

      const _key = getCurrentDate5(new Date())

      const _elapsed = dateDiffInDaysGap(
        new Date(_reg_date.seconds * 1000),
        new Date()
      )
      const _t = {
        // set rowKey
        doc_id: _md + _key,
        name: _name,
        date: getCurrentTime2(new Date()),
        title: getCurrentDate4(new Date(), "월 예상 수익"),
        monthId: _key,
        key: _key + _md.toString(),
        md: _md.toString(),
        profit: "",
        type: "REAL",
        usertype: _usertype,
        elapsed: _elapsed
      }
      self.originalTableData.push(_t)

      await self.onLoadHistoryById(
        _key,
        "REAL",
        _usertype,
        _name,
        _md,
        _elapsed
      )

      await self.onLoadHistory(_usertype, _name, _md, _reg_date, _elapsed)
    },
    async onLoadHistory (_usertype, _name, _md, _reg_date, _elapsed) {
      const self = this
      const db = firebase.firestore()

      await db
        .collection("retail_point_history")
        .where("member_id", "==", _md)
        .where("point_type_cd", "==", "1001")
        .orderBy("withdrawable_date", "desc")
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(async function (doc) {
            let _cumday = "-"
            let _t = {}

            if (doc.data().withdrawable_date) {
              _cumday = getCurrentDate5(
                new Date(doc.data().reg_date.seconds * 1000).addDays(-10)
              )

              const _gap = dateDiffInDaysGap(
                new Date(_reg_date.seconds * 1000),
                new Date(doc.data().reg_date.seconds * 1000)
              )

              _t = {
                // set rowKey
                doc_id: doc.id,
                name: _name,
                date: getCurrentTime2(
                  new Date(doc.data().reg_date.seconds * 1000).addHours(-9)
                ),
                title: getCurrentDate4(
                  new Date(doc.data().reg_date.seconds * 1000).addHours(
                    -24 * 10
                  ),
                  "월 수익"
                ),
                type: "HISTORY",
                monthId: _cumday,
                md: _md.toString(),
                key: _cumday.toString() + _md.toString(),
                profit: `${parseInt(doc.data().add_point).toLocaleString()}원`,
                usertype: _usertype,
                elapsed: _gap
              }
              self.originalTableData.push(_t)
            }
            await self.onLoadHistoryByIdPrev(
              _t.monthId,
              "HISTORY",
              _usertype,
              _name,
              _md,
              _t.elapsed
            )
          })
        })
    },
    async onLoadHistoryById (_monthId, _type, _usertype, _name, _md, _elapsed) {
      const self = this
      const db = firebase.firestore()
      const _k = new Map()
      // const _k2 = new Map()

      // const _totalCampaignComplete = 0

      let _totalSeller = 0
      let _totalFee = 0

      let _totalPerson = 0
      let _totalEventPerson = 0
      let _totalOriginalPerson = 0
      let _totalCampaign = 0
      let _totalCampaignAll = 0
      let _totalCampaignAllDone = 0

      let _totalMissionComplete = 0
      const _totalMissionInComplete = 0

      let _totalPersonPrev = 0
      let _totalEventPersonPrev = 0
      let _totalOriginalPersonPrev = 0
      let _totalCampaignPrev = 0
      const _totalCampaignPrevStr = ""

      let _totalMissionCompletePrev = 0
      const _totalMissionInCompletePrev = 0

      let _totalPrice = 0

      await db
        .collection("retail_campaign")
        .where("member_id", "==", _md.toString())
        .get()
        .then(async function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            //이월
            if (
              doc.data().end_month === _monthId &&
              doc.data().contract_date.substr(0, 6) < _monthId &&
              _type === "REAL"
            ) {
              self.allCampaigns.push({ ...doc.data(), doc_id: doc.id })
              _totalPrice += doc.data().totalvat ? doc.data().totalvat : 0
              _totalCampaignAll++
              //전체 인원수(진행,미진행) 포함
              _totalPersonPrev += doc.data().max_applier_cnt
              _totalEventPersonPrev += doc.data().event_applier_cnt
              _totalOriginalPersonPrev += doc.data().org_applier_cnt
              _totalCampaignPrev += doc.data().max_applier_cnt

              if (doc.data().campaign_state_cd === "0803") {
                _totalMissionCompletePrev += doc.data().org_applier_cnt
                _totalFee += doc.data().per_amount * doc.data().org_applier_cnt
                _totalCampaignAllDone++
              }

              _k.set(doc.data().seller_name, "-")
            } else if (
              doc.data().end_month === _monthId ||
              (doc.data().contract_date.substr(0, 6) === _monthId &&
                doc.data().end_month === null &&
                _type === "REAL")
            ) {
              _totalCampaignAll++
              self.allCampaigns.push({ ...doc.data(), doc_id: doc.id })
              _totalPrice += doc.data().totalvat ? doc.data().totalvat : 0
              //전체 인원수(진행,미진행) 포함
              _totalPerson += doc.data().max_applier_cnt
              _totalEventPerson += doc.data().event_applier_cnt
              _totalOriginalPerson += doc.data().org_applier_cnt
              _totalCampaign += doc.data().max_applier_cnt

              if (doc.data().campaign_state_cd === "0803") {
                _totalMissionComplete += doc.data().org_applier_cnt
                _totalFee += doc.data().per_amount * doc.data().org_applier_cnt
                _totalCampaignAllDone++
              }

              _k.set(doc.data().seller_name, "-")
            }
          })

          _k.forEach(item => {
            _totalSeller++
          })

          let _totalfee_ = _totalFee
          if (_usertype === "FREE") {
            //
          } else if (_elapsed > 180) {
            _totalfee_ = _totalFee - 500000
          }

          const _t = {
            seller: _totalSeller,
            campaign: _totalCampaignAll,
            campaignDone: _totalCampaignAllDone,
            tperson: _totalPerson,
            eperson: _totalEventPerson,
            operson: _totalOriginalPerson,
            missioncomplete: _totalMissionComplete,
            missionincomplete: _totalCampaign - _totalMissionComplete,

            campaignprev: _totalCampaignPrevStr,
            tpersonprev: _totalPersonPrev,
            epersonprev: _totalEventPersonPrev,
            opersonprev: _totalOriginalPersonPrev,
            missioncompleteprev: _totalMissionCompletePrev,
            totalfee: _totalfee_,
            fee: _totalFee,
            price: _totalPrice
          }

          self.originalTableData = self.originalTableData.filter(item => {
            if (item.key === _monthId + _md.toString()) {
              item["seller"] = _t.seller
              item["campaign"] = _t.campaign
              item["campaignDone"] = _t.campaignDone
              item["tperson"] = _t.tperson
              item["eperson"] = _t.eperson
              item["operson"] = _t.operson
              item["missioncomplete"] = _t.missioncomplete

              item["tpersonprev"] = _t.tpersonprev
              item["epersonprev"] = _t.epersonprev
              item["opersonprev"] = _t.opersonprev
              item["missioncompleteprev"] = _t.missioncompleteprev

              item["missionincomplete"] = _t.missionincomplete
              item["totalfee"] = _t.totalfee
              item["fee"] = _t.fee
              item["price"] = _t.price
            }

            return item
          })
        })

      self.tableData = []
      self.tableData = self.originalTableData
    },
    async onLoadHistoryByIdPrev (
      _monthId,
      _type,
      _usertype,
      _name,
      _md,
      _elapsed
    ) {
      const self = this
      const db = firebase.firestore()
      const _k = new Map()
      const _k2 = new Map()

      const _totalCampaignComplete = 0

      let _totalSeller = 0
      let _totalFee = 0

      let _totalPerson = 0
      let _totalEventPerson = 0
      let _totalOriginalPerson = 0
      let _totalCampaign = 0
      let _totalCampaignAll = 0
      let _totalCampaignAllDone = 0

      let _totalMissionComplete = 0
      const _totalMissionInComplete = 0

      const _totalPersonPrev = 0
      const _totalEventPersonPrev = 0
      const _totalOriginalPersonPrev = 0
      const _totalCampaignPrev = 0
      const _totalCampaignPrevStr = ""

      const _totalMissionCompletePrev = 0
      const _totalMissionInCompletePrev = 0

      let _totalPrice = 0

      await db
        .collection("retail_campaign")
        .where("member_id", "==", _md.toString())
        .get()
        .then(async function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            //이월
            if (doc.data().end_month === _monthId) {
              _totalPrice += doc.data().totalvat ? doc.data().totalvat : 0
              self.allCampaigns.push({ ...doc.data(), doc_id: doc.id })
              _totalCampaignAll++
              //전체 인원수(진행,미진행) 포함
              _totalPerson += doc.data().max_applier_cnt
              _totalEventPerson += doc.data().event_applier_cnt
              _totalOriginalPerson += doc.data().org_applier_cnt
              _totalCampaign += doc.data().max_applier_cnt

              if (doc.data().campaign_state_cd === "0803") {
                _totalMissionComplete += doc.data().org_applier_cnt
                _totalFee += doc.data().per_amount * doc.data().org_applier_cnt
                _totalCampaignAllDone++
              }

              _k.set(doc.data().seller_name, "-")
            }
          })

          _k.forEach(item => {
            _totalSeller++
          })

          // _k2.forEach(item => {
          //   _totalSeller2++;
          // });

          let _totalfee_ = _totalFee
          if (_usertype === "FREE") {
            //
          } else if (_elapsed > 180) {
            _totalfee_ = _totalFee - 500000
          }

          const _t = {
            seller: _totalSeller,
            campaign: _totalCampaignAll,
            campaignDone: _totalCampaignAllDone,
            tperson: _totalPerson,
            eperson: _totalEventPerson,
            operson: _totalOriginalPerson,
            missioncomplete: _totalMissionComplete,
            missionincomplete: _totalCampaign - _totalMissionComplete,

            campaignprev: _totalCampaignPrevStr,
            tpersonprev: _totalPersonPrev,
            epersonprev: _totalEventPersonPrev,
            opersonprev: _totalOriginalPersonPrev,
            missioncompleteprev: _totalMissionCompletePrev,
            totalfee: _totalfee_,
            fee: _totalFee,
            price: _totalPrice
          }
          const _dummy = self.originalTableData
          self.originalTableData = _dummy.filter(item => {
            if (item.monthId === _monthId && item.md === _md) {
              item["seller"] = _t.seller
              item["campaign"] = _t.campaign
              item["campaignDone"] = _t.campaignDone
              item["tperson"] = _t.tperson
              item["eperson"] = _t.eperson
              item["operson"] = _t.operson
              item["missioncomplete"] = _t.missioncomplete

              item["tpersonprev"] = _t.tpersonprev
              item["epersonprev"] = _t.epersonprev
              item["opersonprev"] = _t.opersonprev
              item["missioncompleteprev"] = _t.missioncompleteprev

              item["missionincomplete"] = _t.missionincomplete
              item["totalfee"] = _t.totalfee
              item["price"] = _t.price
              item["fee"] = _t.fee
            }
            return item
          })
        })

      self.tableData = self.originalTableData
    }
  }
}
</script>